module.exports = __webpack_public_path__ + "static/media/Klinklang_gaussian2.dfcae3ec.png";